var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
// dev-doc: 2026-06-18 19:27 fix-mobile-emoji-build
import './css/site.scss';
import './Editor/layers.js';
import './featureTracking.js';
import React, { useState, useEffect, useRef, createContext, useContext, useCallback } from 'react';
import { useNavigate, useLocation, BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import ReactDOM from 'react-dom/client';
import MapEditor from './Editor/MapEditor';
import UpgradeToPro from './Subscribe/UpgradeToPro';
import { Workbox } from 'workbox-window';
import MapsPage from './MapList/MapsPage';
import MapDetails from './MapList/MapDetails';
import HelpPage from './HelpPage';
import './i18n'; // Import i18next configuration
import { useTranslation } from 'react-i18next';
var version = '2.0.0';
var hexToEmoji = function (hex) { return String.fromCodePoint.apply(String, __spreadArray([], __read(hex.split('-').map(function (h) { return parseInt(h, 16); })), false)); };
var languages = [
    // English
    { code: 'en-us', name: 'English (United States)', shortName: 'English', flag: '1f1fa-1f1f8' }, // 🇺🇸
    { code: 'en-gb', name: 'English (United Kingdom)', shortName: 'English', flag: '1f1ec-1f1e7' }, // 🇬🇧
    { code: 'en-ca', name: 'English (Canada)', shortName: 'English', flag: '1f1e8-1f1e6' }, // 🇨🇦
    { code: 'en-au', name: 'English (Australia)', shortName: 'English', flag: '1f1e6-1f1fa' }, // 🇦🇺
    // Chinese
    { code: 'zh-cn', name: '简体中文 (中国)', shortName: '简体中文', flag: '1f1e8-1f1f3' }, // 🇨🇳
    { code: 'zh-tw', name: '繁體中文 (台灣)', shortName: '繁體中文', flag: '1f1f9-1f1fc' }, // 🇹🇼
    { code: 'zh-hk', name: '香港中文 (香港)', shortName: '香港中文', flag: '1f1ed-1f1f0' }, // 🇭🇰
    // Spanish
    { code: 'es-es', name: 'Español (España)', shortName: 'Español', flag: '1f1ea-1f1f8' }, // 🇪🇸
    { code: 'es-mx', name: 'Español (México)', shortName: 'Español', flag: '1f1f2-1f1fd' }, // 🇲🇽
    { code: 'es-co', name: 'Español (Colombia)', shortName: 'Español', flag: '1f1e8-1f1f4' }, // 🇨🇴
    { code: 'es-ar', name: 'Español (Argentina)', shortName: 'Español', flag: '1f1e6-1f1f7' }, // 🇦🇷
    // Hindi
    { code: 'hi', name: 'हिन्दी (भारत)', shortName: 'हिन्दी', flag: '1f1ee-1f1f3' }, // 🇮🇳
    // Arabic
    { code: 'ar-sa', name: 'العربية (السعودية)', shortName: 'العربية', flag: '1f1f8-1f1e6' }, // 🇸🇦
    { code: 'ar-eg', name: 'العربية (مصر)', shortName: 'العربية', flag: '1f1ea-1f1ec' }, // 🇪🇬
    { code: 'ar-ae', name: 'العربية (الإمارات)', shortName: 'العربية', flag: '1f1e6-1f1ea' }, // 🇦🇪
    { code: 'ar-ma', name: 'العربية (المغرب)', shortName: 'العربية', flag: '1f1f2-1f1e6' }, // 🇲🇦
    // Portuguese
    { code: 'pt-br', name: 'Português (Brasil)', shortName: 'Português', flag: '1f1e7-1f1f7' }, // 🇧🇷
    { code: 'pt-pt', name: 'Português (Portugal)', shortName: 'Português', flag: '1f1f5-1f1f9' }, // 🇵🇹
    // Italian
    { code: 'it-it', name: 'Italiano (Italia)', shortName: 'Italiano', flag: '1f1ee-1f1f9' }, // 🇮🇹
    // Bengali
    { code: 'bn', name: 'বাংলা (বাংলাদেশ)', shortName: 'বাংলা', flag: '1f1e7-1f1e9' }, // 🇧🇩
    { code: 'bn-in', name: 'বাংলা (ভারত)', shortName: 'বাংলা', flag: '1f1ee-1f1f3' }, // 🇮🇳
    // Russian
    { code: 'ru', name: 'Русский (Россия)', shortName: 'Русский', flag: '1f1f7-1f1fa' }, // 🇷🇺
    // Japanese
    { code: 'ja', name: '日本語 (日本)', shortName: '日本語', flag: '1f1ef-1f1f5' }, // 🇯🇵
    // Korean
    { code: 'ko', name: '한국어 (대한민국)', shortName: '한국어', flag: '1f1f0-1f1f7' }, // 🇰🇷
    // Punjabi
    { code: 'pa-in', name: 'ਪੰਜਾਬੀ (ਭਾਰਤ)', shortName: 'ਪੰਜਾਬੀ', flag: '1f1ee-1f1f3' }, // 🇮🇳
    { code: 'pa-pk', name: 'پنجابی (پاکستان)', shortName: 'پنجابی', flag: '1f1f5-1f1f0' }, // 🇵🇰
    // Javanese
    { code: 'jv', name: 'ꦧꦱꦗꦮ (Indonesia)', shortName: 'ꦧꦱꦗꦮ', flag: '1f1ee-1f1e9' }, // 🇮🇩
    // Telugu
    { code: 'te', name: 'తెలుగు (భారతదేశం)', shortName: 'తెలుగు', flag: '1f1ee-1f1f3' }, // 🇮🇳
    // Tamil
    { code: 'ta', name: 'தமிழ் (இந்தியா)', shortName: 'தமிழ்', flag: '1f1ee-1f1f3' }, // 🇮🇳
    { code: 'ta-lk', name: 'தமிழ் (இலங்கை)', shortName: 'தமிழ்', flag: '1f1f1-1f1f0' }, // 🇱🇰
    // Urdu
    { code: 'ur-pk', name: 'اردو (پاکستان)', shortName: 'اردو', flag: '1f1f5-1f1f0' }, // 🇵🇰
    { code: 'ur-in', name: 'اردو (بھارت)', shortName: 'اردو', flag: '1f1ee-1f1f3' }, // 🇮🇳
    // Vietnamese
    { code: 'vi', name: 'Tiếng Việt (Việt Nam)', shortName: 'Tiếng Việt', flag: '1f1fb-1f1f3' }, // 🇻🇳
    // Malay
    { code: 'ms-my', name: 'Bahasa Melayu (Malaysia)', shortName: 'Bahasa Melayu', flag: '1f1f2-1f1fe' }, // 🇲🇾
    { code: 'ms-id', name: 'Bahasa Melayu (Indonesia)', shortName: 'Bahasa Melayu', flag: '1f1ee-1f1e9' }, // 🇮🇩
    // Hausa
    { code: 'ha-ng', name: 'Hausa (Nigeria)', shortName: 'Hausa', flag: '1f1f3-1f1ec' }, // 🇳🇬
    // Amharic
    /*  { code: 'am', name: 'አማርኛ (ኢትዮጵያ)', shortName: 'አማርኛ', flag: '1f1ea-1f1f9' }, // 🇪🇹 */
    // Burmese
    { code: 'my', name: 'မြန်မာစာ (မြန်မာ)', shortName: 'မြန်မာစာ', flag: '1f1f2-1f1f2' }, // 🇲🇲
    // Thai
    { code: 'th', name: 'ภาษาไทย (ประเทศไทย)', shortName: 'ภาษาไทย', flag: '1f1f9-1f1ed' }, // 🇹🇭
    // Nepali
    { code: 'ne', name: 'नेपाली (नेपाल)', shortName: 'नेपाली', flag: '1f1f3-1f1f5' }, // 🇳🇵
    // Khmer
    { code: 'km', name: 'ខ្មែរ (កម្ពុជា)', shortName: 'ខ្មែរ', flag: '1f1f0-1f1ed' }, // 🇰🇭
    // French
    { code: 'fr-fr', name: 'Français (France)', shortName: 'Français', flag: '1f1eb-1f1f7' }, // 🇫🇷
    { code: 'fr-ca', name: 'Français (Canada)', shortName: 'Français', flag: '1f1e8-1f1e6' }, // 🇨🇦
    // German
    { code: 'de-de', name: 'Deutsch (Deutschland)', shortName: 'Deutsch', flag: '1f1e9-1f1ea' }, // 🇩🇪
    { code: 'de-at', name: 'Deutsch (Österreich)', shortName: 'Deutsch', flag: '1f1e6-1f1f9' }, // 🇦🇹
    { code: 'de-ch', name: 'Deutsch (Schweiz)', shortName: 'Deutsch', flag: '1f1e8-1f1ed' }, // 🇨🇭
    // Polish
    { code: 'pl', name: 'Polski (Polska)', shortName: 'Polski', flag: '1f1f5-1f1f1' }, // 🇵🇱
    // Turkish
    { code: 'tr', name: 'Türkçe (Türkiye)', shortName: 'Türkçe', flag: '1f1f9-1f1f7' }, // 🇹🇷
    // Ukrainian
    { code: 'uk', name: 'Українська (Україна)', shortName: 'Українська', flag: '1f1fa-1f1e6' }, // 🇺🇦
    // Greek
    { code: 'el', name: 'Ελληνικά (Ελλάδα)', shortName: 'Ελληνικά', flag: '1f1ec-1f1f7' }, // 🇬🇷
    // Swedish
    { code: 'sv', name: 'Svenska (Sverige)', shortName: 'Svenska', flag: '1f1f8-1f1ea' }, // 🇸🇪
];
var RequireAuth = function (_a) {
    var children = _a.children;
    var _b = useContext(AppContext), isLoggedIn = _b.isLoggedIn, redirectView = _b.redirectView;
    var location = useLocation();
    if (!isLoggedIn) {
        redirectView.current = location.pathname;
        // Redirect to the login page
        return React.createElement(Navigate, { to: "/login", replace: true });
    }
    return children;
};
var checkThemePreference = function () {
    if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
        return 'dark';
    }
    return 'light';
};
var afterToday = function (dateString) {
    var today = new Date();
    var compare = new Date(dateString);
    if (compare.getTime() > today.getTime()) {
        return true;
    }
    return false;
};
var validProducts = function (validProducts, products) {
    if (products) {
        for (var i = 0; i < products.length; i++) {
            if (validProducts.indexOf(+products[i]['productId']) != -1 && afterToday(products[i]['expires'])) {
                return true;
                break;
            }
        }
    }
    return false;
};
var isPro = function (products) {
    if (!products)
        return false;
    var p = [];
    for (var i = 2; i <= 32; i++)
        p.push(i);
    if (validProducts(p, products)) {
        return true;
    }
    return false;
};
var isPremium = function (products) {
    if (!products)
        return false;
    return validProducts([16], products);
};
var isProBusiness = function (products) {
    if (!products)
        return false;
    return validProducts([19, 20, 21, 22, 29, 30], products);
};
var canTrial = function (products) {
    if (!products)
        return false;
    return products.length == 0;
};
var intervalId;
window.hasAnUpdate = false;
if ('serviceWorker' in navigator) {
    var wb_1 = new Workbox('/sw.js');
    window.wb = wb_1;
    // Add an event listener to detect when the registered
    // service worker has installed but is waiting to activate.
    wb_1.addEventListener('waiting', function (event) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            window.hasAnUpdate = true;
            window.canUpdate && window.canUpdate();
            return [2 /*return*/];
        });
    }); });
    //c7
    window.reloadApp = function () {
        wb_1.addEventListener('controlling', function (event) {
            window.location.reload();
        });
        wb_1.messageSkipWaiting();
    };
    // Register the service worker after event listeners have been added.
    wb_1.register().then(function (registration) {
        intervalId = setInterval(function () {
            wb_1.update();
        }, 1000 * 5);
    });
}
var test = 5;
var isLocalHost = window.location.hostname === 'localhost';
var isStaging = window.location.hostname.indexOf('staging') > -1;
var apiDomain = isLocalHost
    ? 'https://localhost:44352/api'
    : isStaging
        ? 'https://staging.scribblemaps.com/api'
        : 'https://www.scribblemaps.com/api';
var loginDomain = isLocalHost
    ? 'https://localhost:44352/account/login'
    : isStaging
        ? 'https://staging.scribblemaps.com/account/login'
        : 'https://www.scribblemaps.com/account/login';
var localDomain = isLocalHost
    ? 'https://localhost:7008'
    : isStaging
        ? 'https://lite-staging.scribblemaps.com'
        : 'https://lite.scribblemaps.com';
export var AppContext = createContext(null);
var pendingGoogleLogin = null;
var loginPoll = null;
var App = function () {
    var _a = __read(useState(false), 2), isLoggedIn = _a[0], setIsLoggedIn = _a[1];
    var _b = __read(useState(null), 2), mapsList = _b[0], setMapsList = _b[1];
    var _c = __read(useState(null), 2), selectedMap = _c[0], setSelectedMap = _c[1];
    var _d = __read(useState(null), 2), selectedEditMap = _d[0], setSelectedEditMap = _d[1];
    var _e = __read(useState(null), 2), driveState = _e[0], setDriveState = _e[1];
    var _f = __read(useState('326px'), 2), loginHeight = _f[0], setLoginHeight = _f[1];
    var _g = __read(useState(false), 2), editorInitialized = _g[0], setEditorInitialized = _g[1];
    var _h = __read(useState(false), 2), loginFrameLoaded = _h[0], setloginFrameLoaded = _h[1];
    var _j = __read(useState(''), 2), email = _j[0], setEmail = _j[1];
    var _k = __read(useState(false), 2), showSaveInfo = _k[0], setShowSaveInfo = _k[1];
    var _l = __read(useState(false), 2), updatingApp = _l[0], setUpdatingApp = _l[1];
    var _m = __read(useState(null), 2), waitingView = _m[0], setWaitingView = _m[1];
    var saveCallbackRef = useRef(null);
    var _o = __read(useState([]), 2), products = _o[0], setProducts = _o[1];
    var _p = __read(useState(false), 2), justUpgraded = _p[0], setJustUpgraded = _p[1];
    var _q = __read(useState(false), 2), conversionTracked = _q[0], setConversionTracked = _q[1];
    var _r = __read(useState(false), 2), hasClose = _r[0], setHasClose = _r[1];
    var _s = __read(useState(null), 2), hasTitle = _s[0], setHasTitle = _s[1];
    var _t = __read(useState(checkThemePreference()), 2), theme = _t[0], setTheme = _t[1];
    var redirectView = useRef(null);
    var mapEditorRef = useRef(null);
    var navigate = useNavigate();
    var location = useLocation();
    var teamMaps = useRef(null);
    var personalMaps = useRef(null);
    var thumbnailCache = useRef({});
    var _u = useTranslation(), t = _u.t, i18n = _u.i18n;
    var checkAndUpdate = function (force) {
        if (window.hasAnUpdate) {
            setUpdatingApp(true);
            if (force) {
                window.reloadApp();
            }
        }
    };
    //c
    var invalidateMapList = function () {
        teamMaps.current = null;
        personalMaps.current = null;
        setMapsList(null);
        setSelectedMap(null);
    };
    var checkIsLoggedIn = useCallback(function (path, poll) { return __awaiter(void 0, void 0, void 0, function () {
        var sm, response, data, error_1, script;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    sm = window.sm;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 5, , 6]);
                    if (!navigator.onLine) return [3 /*break*/, 4];
                    return [4 /*yield*/, fetch(path, {
                            credentials: 'include',
                            method: 'GET',
                            headers: {
                                'Content-Type': 'application/json'
                            }
                        })];
                case 2:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 3:
                    data = _a.sent();
                    if (!data.email) {
                        throw new Error('Not logged in');
                    }
                    window.appSettings = data;
                    if (sm) {
                        sm.settings.updateCredentials(window.appSettings || {});
                    }
                    if (data.email == email) {
                        return [2 /*return*/];
                    }
                    setProducts(data.products || []);
                    setEmail(data.email);
                    setIsLoggedIn(true);
                    _a.label = 4;
                case 4:
                    if (!loginPoll && !poll) {
                        loginPoll = setInterval(function () {
                            checkIsLoggedIn("".concat(apiDomain, "/account?type=lite"), true);
                        }, 60 * 1000);
                    }
                    return [3 /*break*/, 6];
                case 5:
                    error_1 = _a.sent();
                    // Set up the One-Tap login callback
                    if (!poll) {
                        window.oneTapLogin = function (data) {
                            window.appLogin(data); // Assuming appLogin is defined elsewhere
                        };
                        script = document.createElement('script');
                        script.src = 'https://accounts.google.com/gsi/client';
                        script.async = true;
                        script.defer = true;
                        document.body.appendChild(script);
                    }
                    handleLogout(true);
                    return [3 /*break*/, 6];
                case 6: return [2 /*return*/];
            }
        });
    }); }, []);
    useEffect(function () {
        checkAndUpdate(true);
        //checkIsLoggedIn(`/api/account/isLoggedIn`);
        checkIsLoggedIn("".concat(apiDomain, "/account?type=lite"));
    }, []);
    useEffect(function () {
        if (driveState && isLoggedIn) {
            navigate('/editor');
        }
        else if (driveState && !isLoggedIn) {
            navigate('/login');
        }
    }, [driveState, isLoggedIn]);
    useEffect(function () {
        window.canUpdate = function () {
            if (window.hasAnUpdate) {
                setUpdatingApp(true);
            }
        };
    }, []);
    useEffect(function () {
        var pathName = location.pathname;
        if (pathName.indexOf('help') > -1) {
            setHasClose(true);
            setHasTitle(t("help_page.header"));
        }
        else if (pathName.indexOf('maps/view') > -1) {
            setHasTitle(null);
            setHasClose(true);
        }
        else if (pathName.indexOf('languages') > -1) {
            setHasTitle(t("set_language"));
            setHasClose(true);
        }
        else {
            setHasTitle(null);
            setHasClose(false);
        }
    }, [location.pathname]);
    useEffect(function () {
        window.upgradeToPro = function () {
            navigate('/upgrade');
        };
    }, []);
    useEffect(function () {
        window.loggedIn = function () { return __awaiter(void 0, void 0, void 0, function () {
            var error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        // Call the checkIsLoggedIn function to get the latest login status and email
                        return [4 /*yield*/, checkIsLoggedIn("".concat(apiDomain, "/account?type=lite"))];
                    case 1:
                        // Call the checkIsLoggedIn function to get the latest login status and email
                        _a.sent();
                        invalidateMapList();
                        if (window.sm) {
                            window.sm.settings.updateCredentials(window.appSettings || {});
                        }
                        // Ensure the appSettings and isLoggedIn state are updated after API call
                        setIsLoggedIn(true);
                        navigate(redirectView.current || '/maps/personal', { replace: true });
                        redirectView.current = null;
                        return [3 /*break*/, 3];
                    case 2:
                        error_2 = _a.sent();
                        console.error('Error during loggedIn function execution:', error_2);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
    }, [location]);
    var getCallbackUrl = function () {
        var callbackUrl = "".concat(localDomain, "/loggedin").concat(theme == "dark" ? "?dark=1" : "");
        return callbackUrl;
    };
    var loginFrame = useRef(null);
    var loginSrc = "".concat(loginDomain, "?force&type=lite&callback=").concat(getCallbackUrl()).concat(theme == "dark" ? "&dark" : "", "&lang=").concat(i18n.language);
    useEffect(function () {
        if (loginFrameLoaded && pendingGoogleLogin) {
            loginFrame.current.contentWindow.postMessage(JSON.stringify(pendingGoogleLogin), '*');
            pendingGoogleLogin = null;
        }
    }, [loginFrameLoaded]);
    useEffect(function () {
        window.appLogin = function (data) {
            pendingGoogleLogin = { type: 'googleLogin', onetap: data };
            navigate('/login');
        };
        window.addEventListener('message', function (event) {
            try {
                if (event.data == 'loginFrameLoaded') {
                    setloginFrameLoaded(true);
                }
                else {
                    if (event.data && typeof event.data === 'string') {
                        var data = JSON.parse(event.data);
                        if (data.type === 'loginSize') {
                            setLoginHeight(Math.max(396, data.height) + 'px');
                        }
                    }
                }
            }
            catch (e) {
                console.log('error', e);
            }
        });
    }, []);
    // Handle back button navigation
    useEffect(function () {
        window.showLogin = function () {
            setIsLoggedIn(false);
            navigate('/login');
        };
    }, []);
    var handleOptionClick = function (option) {
        setSelectedMap(null);
        if (option === "Your Maps" /* MenuOptions.YourMaps */) {
            navigate('/maps/personal');
        }
        else if (option === "Purchased Maps" /* MenuOptions.PurchasedMaps */) {
            navigate('/maps/paid');
        }
        else if (option === "Create Map" /* MenuOptions.CreateMap */) {
            setShowSaveInfo(false);
            saveCallbackRef.current = null;
            navigate('/editor');
        }
        else if (option === 'upgrade') {
            navigate('/upgrade');
        }
    };
    useEffect(function () {
        var getCookie = function (name) {
            var e_1, _a;
            var cookies = document.cookie.split(';');
            try {
                for (var cookies_1 = __values(cookies), cookies_1_1 = cookies_1.next(); !cookies_1_1.done; cookies_1_1 = cookies_1.next()) {
                    var cookie = cookies_1_1.value;
                    var _b = __read(cookie.trim().split('='), 2), key = _b[0], value = _b[1];
                    if (key === name) {
                        return decodeURIComponent(value);
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (cookies_1_1 && !cookies_1_1.done && (_a = cookies_1.return)) _a.call(cookies_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return null;
        };
        var smDriveState = getCookie('sm_drive_state');
        //not null or blank
        if (smDriveState != "" && smDriveState != null) {
            setDriveState(JSON.parse(decodeURIComponent(smDriveState)));
            redirectView.current = "/editor";
            if (!isLoggedIn) {
                navigate('/login');
            }
        }
    }, []);
    useEffect(function () {
        if (driveState && !isLoggedIn) {
            navigate('/login');
        }
        else if (driveState && isLoggedIn) {
            navigate('/editor');
        }
    }, [isLoggedIn, driveState]);
    var handleLogout = useCallback(function (skipFetch) {
        // Perform logout logic
        clearInterval(loginPoll);
        loginPoll = null;
        if (window.zE != null) {
            var zE = window.zE;
            zE('webWidget', 'logout');
            zE('webWidget', 'clear');
            zE('webWidget', 'prefill', {
                email: {
                    value: null,
                    readOnly: false
                }
            });
        }
        setIsLoggedIn(false);
        setProducts([]);
        setEmail('');
        if (!skipFetch) {
            fetch("".concat(apiDomain, "/account/logout"), { credentials: 'include', method: 'POST' }).then(function () {
                if (window.sm) {
                    window.sm.settings.updateCredentials({});
                }
            });
        }
        personalMaps.current = null;
        teamMaps.current = null;
        if (window.sm) {
            window.sm.settings.updateCredentials({});
            window.sm.map.createNewMap();
        }
        invalidateMapList();
    }, []);
    var getMapUrl = useCallback(function (map) {
        var title = map.title.replace(/ /g, '_');
        title = encodeURIComponent(title);
        return "https://www.scribblemaps.com/maps/view/".concat(title, "/").concat(map.mapCode);
    }, []);
    var navigatorShare = useCallback(function (map) {
        window.FeatureTracking.trackEditorEvent('share');
        navigator.share({
            title: map.title,
            text: map.description,
            url: getMapUrl(map)
        });
    }, []);
    var _v = __read(useState(false), 2), updateVisible = _v[0], setUpdateVisible = _v[1];
    useEffect(function () {
        if (updatingApp) {
            // Start with the component hidden, then add visible class after a short delay
            setTimeout(function () {
                setUpdateVisible(true);
            }, 0);
        }
        else {
            setUpdateVisible(false);
        }
    }, [updatingApp]);
    useEffect(function () {
        document.body.className = theme;
        loginFrame.current = null;
        setloginFrameLoaded(false);
        window.scribblemaps = window.scribblemaps || {};
        window.scribblemaps.settings = window.scribblemaps.settings || {};
        window.scribblemaps.settings.theme = theme;
    }, [theme]);
    //if view/:mapCode but selected map is null selected map needs to be set
    useEffect(function () {
        var mapCode;
        /* if(location.pathname.indexOf('editor') > -1 && selectedMap == null) {
          mapCode = location.pathname.split('/')[2];
        } else */ if (location.pathname.indexOf('view') > -1 && selectedMap == null) {
            mapCode = location.pathname.split('/')[3];
        }
        if (mapCode) {
            var maps = (personalMaps.current || []).concat(teamMaps.current || []);
            var map = maps.find(function (m) { return m.mapCode == mapCode; });
            if (!map) {
                setSelectedMap({ mapCode: mapCode, title: 'Loading...', description: 'Loading...', fetchData: true });
            }
            else {
                setSelectedMap(map);
            }
        }
    }, [location.pathname, isLoggedIn]);
    useEffect(function () {
        if (window.gtag) {
            if (justUpgraded && !conversionTracked) {
                setConversionTracked(true);
                window.gtag('event', 'conversion', {
                    'send_to': 'AW-1041052376/o9lsCIX2uMgCENjltPAD',
                    'value': window['valueUSD'] || 0,
                    'currency': 'USD',
                    'transaction_id': ''
                });
            }
        }
    }, [justUpgraded]);
    var changeLanguage = function (lang) {
        //find the language
        var language = languages.find(function (l) { return l.code == lang; });
        if (!language) {
            //find closest based on language code
            language = languages.find(function (l) { return l.code.indexOf(lang) > -1; });
            if (!language) {
                language = languages[0];
            }
        }
        i18n.changeLanguage(lang); // Change language
    };
    //for debug;
    // Gated on isLocalHost, so it can only ever be true when the hostname is literally "localhost"
    // (see the const above). Lets /editor mount without an auth round trip, which is the only way to
    // exercise the editor against the LOCAL SMJS that appsettings.Development.json points /debug at.
    var forceEditor = isLocalHost;
    //v2
    return (React.createElement(AppContext.Provider, { value: { isLoggedIn: isLoggedIn, t: t, i18n: i18n, driveState: driveState, setDriveState: setDriveState, setIsLoggedIn: setIsLoggedIn, checkAndUpdate: checkAndUpdate, waitingView: waitingView, setSelectedMap: setSelectedMap, selectedMap: selectedMap, setWaitingView: setWaitingView, isPro: isPro, navigatorShare: navigatorShare, setSelectedEditMap: setSelectedEditMap, selectedEditMap: selectedEditMap, mapEditorRef: mapEditorRef, products: products, teamMaps: teamMaps, personalMaps: personalMaps, apiDomain: apiDomain, justUpgraded: justUpgraded, setJustUpgraded: setJustUpgraded, isProBusiness: isProBusiness, redirectView: redirectView, setTheme: setTheme, theme: theme, isPremium: isPremium, canTrial: canTrial, thumbnailCache: thumbnailCache } },
        React.createElement("div", null,
            justUpgraded && React.createElement("div", { className: 'justUpgraded' },
                React.createElement("h3", null, "Thank you for upgrading to Pro!"),
                React.createElement("button", { onMouseUp: function () {
                        setJustUpgraded(false);
                    } }, "Close")),
            updatingApp && (React.createElement("div", { className: "updateApp ".concat(updateVisible ? 'visible' : '') },
                React.createElement("div", { className: "message" }, t('update_available')),
                React.createElement("div", { className: "button", onMouseUp: function () {
                        window.FeatureTracking.trackEditorEvent('update');
                        checkAndUpdate(true);
                    } }, t('update_now')),
                React.createElement("div", { className: 'close', onMouseUp: function () {
                        setUpdateVisible(false);
                        setTimeout(function () {
                            setUpdateVisible(true);
                        }, 1000 * 60 * 5);
                    } }))),
            location.pathname !== '/' && (React.createElement(Header, { isLoggedIn: isLoggedIn, onLogout: handleLogout, onMenuToggle: function () { return navigate("/"); }, products: products, navigate: navigate, hasClose: hasClose, hasTitle: hasTitle })),
            React.createElement("div", { className: "content ".concat(location.pathname.substring(1).split('/')[0] || "menu") },
                React.createElement(Routes, null,
                    React.createElement(Route, { path: "/", element: React.createElement(MenuComponent, { email: email, onOptionClick: handleOptionClick, onLogout: function () {
                                handleLogout();
                            } }) }),
                    React.createElement(Route, { path: "maps" },
                        React.createElement(Route, { path: "view/:mapCode", element: React.createElement(RequireAuth, null,
                                selectedMap && React.createElement(MapDetails, { map: selectedMap }),
                                !selectedMap && React.createElement(Navigate, { to: "/maps/personal" })) }),
                        React.createElement(Route, { path: ":mapListType", element: React.createElement(RequireAuth, null,
                                React.createElement(MapsPage, { setSelectedMap: setSelectedMap, selectedMap: selectedMap })) })),
                    React.createElement(Route, { path: "/languages", element: React.createElement("ul", null, languages.map(function (lang) { return (React.createElement("li", { key: lang.code, onClick: function () {
                                changeLanguage(lang.code);
                                navigate(-1);
                            }, className: i18n.language == lang.code ? 'selected' : '' },
                            hexToEmoji(lang.flag),
                            React.createElement("div", { className: 'name' }, lang.name))); })) }),
                    React.createElement(Route, { path: "/upgrade", element: React.createElement(RequireAuth, null,
                            React.createElement(UpgradeToPro, null)) }),
                    React.createElement(Route, { path: "/login", element: React.createElement(LoginComponent, { height: loginHeight, isLoggedIn: isLoggedIn, loginFrameLoaded: loginFrameLoaded, loginFrame: loginFrame, loginSrc: loginSrc }) }),
                    React.createElement(Route, { path: "/help", element: React.createElement(HelpPage, null) }),
                    forceEditor && React.createElement(Route, { path: "/editor", element: React.createElement("div", { style: { display: 'none' } }) }),
                    !forceEditor && React.createElement(Route, { path: "/editor", element: React.createElement(RequireAuth, null,
                            React.createElement("div", { style: { display: 'none' } })) })),
                (mapEditorRef.current != null || (location.pathname.indexOf('/editor') > -1 && (isLoggedIn || forceEditor))) && (React.createElement("div", null, React.createElement("div", { className: "mapEditor", ref: mapEditorRef, style: { visibility: location.pathname.indexOf('/editor') > -1 ? 'visible' : 'hidden' } },
                    React.createElement(MapEditor, { setShowSaveInfo: setShowSaveInfo, showSaveInfo: showSaveInfo, saveCallbackRef: saveCallbackRef, share: navigatorShare, onInitialized: function () { return setEditorInitialized(true); }, invalidateMapList: function (map, skipNavigate) {
                            invalidateMapList();
                            if (!skipNavigate) {
                                setSelectedMap(map);
                                navigate("/maps/view/".concat(map.mapCode));
                                checkAndUpdate();
                            }
                        } }))))))));
};
var LoginComponent = function (_a) {
    var height = _a.height, loginFrameLoaded = _a.loginFrameLoaded, loginFrame = _a.loginFrame, loginSrc = _a.loginSrc, isLoggedIn = _a.isLoggedIn;
    var _b = __read(useState(null), 2), iframeSrc = _b[0], setIframeSrc = _b[1];
    var redirectView = useContext(AppContext).redirectView;
    var navigate = useNavigate();
    useEffect(function () {
        if (isLoggedIn) {
            navigate(redirectView.current || "/"); // Redirect to home if already logged in
        }
    }, [isLoggedIn, navigate]);
    // Only set the iframe src once on the first render
    useEffect(function () {
        if (!iframeSrc) {
            setIframeSrc(decodeURIComponent(loginSrc));
        }
    }, [loginSrc, iframeSrc]);
    if (!isLoggedIn) {
        return (React.createElement("div", { style: { position: 'relative', minHeight: height, width: '100%', zIndex: 50 } },
            !loginFrameLoaded && (React.createElement("div", { className: "loader", style: { position: 'absolute', top: 0, left: 0, right: 0, bottom: 0 } })),
            React.createElement("iframe", { style: {
                    width: '100%',
                    height: height,
                    border: 'none',
                    opacity: loginFrameLoaded ? 1 : 0
                }, src: iframeSrc, ref: loginFrame, className: "loginFrame" })));
    }
    return null;
};
var Header = function (_a) {
    var isLoggedIn = _a.isLoggedIn, onLogout = _a.onLogout, onMenuToggle = _a.onMenuToggle, products = _a.products, navigate = _a.navigate, hasClose = _a.hasClose, hasTitle = _a.hasTitle;
    return (React.createElement("div", { className: "header" },
        React.createElement("button", { className: "menu-button", onMouseUp: onMenuToggle }, "\u2630"),
        hasTitle && React.createElement("h1", null, hasTitle),
        hasClose && React.createElement("div", { className: "close", onMouseUp: function () { navigate(-1); } })));
};
//c
var MenuComponent = function (_a) {
    var onOptionClick = _a.onOptionClick, onLogout = _a.onLogout, email = _a.email;
    var _b = useContext(AppContext), isLoggedIn = _b.isLoggedIn, products = _b.products, isProBusiness = _b.isProBusiness, theme = _b.theme, setTheme = _b.setTheme, isPro = _b.isPro, selectedMap = _b.selectedMap, mapEditorRef = _b.mapEditorRef, t = _b.t, i18n = _b.i18n;
    var navigate = useNavigate();
    useEffect(function () {
        var checkReferrer = function () {
            // Check if the user has navigated within the app or from an external site
            var currentDomain = window.location.hostname;
            var referrer = document.referrer;
        };
        // Run the check whenever the route changes
        checkReferrer();
        // Add a listener for navigation events (dynamic navigation handling)
        return function () {
            window.removeEventListener('popstate', checkReferrer);
        };
    }, [location.pathname]);
    return (React.createElement("div", { className: "navWrapper" },
        React.createElement("div", { className: "nav".concat(!isLoggedIn ? ' noLogin' : '') },
            React.createElement("div", { className: 'buttons' },
                React.createElement("div", { className: "logo" },
                    React.createElement("div", { className: "lite" }, isPro(products) ? 'Pro Lite' : 'Lite')),
                React.createElement("ul", null,
                    React.createElement("li", { onMouseUp: function () { return onOptionClick("Your Maps" /* MenuOptions.YourMaps */); } }, t("your_maps")),
                    React.createElement("li", { onMouseUp: function () { return onOptionClick("Create Map" /* MenuOptions.CreateMap */); }, className: "create" }, (window.sm != null && isLoggedIn) ? t('continue_map') : t('create_a_map'))),
                React.createElement("div", { className: "themeSelector", onMouseUp: function () {
                        if (theme == 'light') {
                            setTheme('dark');
                        }
                        else {
                            setTheme('light');
                        }
                    } },
                    React.createElement("div", { className: "light".concat(theme == "light" ? " selected" : "") },
                        React.createElement("span", null, "\u2600\uFE0F")),
                    React.createElement("div", { className: "dark".concat(theme == "dark" ? " selected" : "") },
                        React.createElement("span", null, "\uD83C\uDF19"))),
                React.createElement("div", { className: 'languageSelector' },
                    React.createElement("button", { onClick: function () { navigate('/languages'); } },
                        hexToEmoji(languages.find(function (l) { return l.code == i18n.language; }).flag),
                        React.createElement("span", null, languages.find(function (l) { return l.code == i18n.language; }).shortName)))),
            isLoggedIn && (React.createElement("div", { className: "loggedIn" },
                React.createElement("div", null,
                    React.createElement("h2", null, t('logged_in')),
                    React.createElement("div", null, email),
                    React.createElement("button", { onMouseUp: onLogout }, t('logout')))))),
        isLoggedIn && mapEditorRef.current != null && React.createElement("div", { className: "close", onMouseUp: function () {
                navigate(-1);
            } }),
        !isLoggedIn && (React.createElement("div", { id: "g_id_onload", "data-client_id": "267184281790-ens070rgikfrk9p595ubufg8b17i9dsb.apps.googleusercontent.com", "data-context": "signin", "data-callback": "oneTapLogin", "data-itp_support": "true", "data-theme": "dark", style: { display: 'none' } })),
        React.createElement("div", { className: "termsPrivacy" },
            (isLoggedIn && !isProBusiness(products)) && React.createElement("div", { className: "upgrade", onMouseUp: function () { return window.upgradeToPro(); } }, t('upgrade')),
            React.createElement("a", { href: "https://help.scribblemaps.com/hc/en-us/community/topics", target: "_blank" }, t('forum')),
            React.createElement("a", { href: "https://www.scribblemaps.com/terms", target: "_blank" }, t('terms')),
            React.createElement("a", { href: "https://www.scribblemaps.com/privacy", target: "_blank" }, t('privacy')))));
};
var rootElement = document.getElementById('root');
var root = ReactDOM.createRoot(rootElement); // Using createRoot instead of render
root.render(React.createElement(BrowserRouter, { future: { v7_startTransition: true } },
    React.createElement(App, null)));
//2024-11-11
